<template>
  <a id="chatItem-{{ chatGroup.id }}"
    class="item-link chatItem item-content actionsSheetTaphold"
    @click="handleClick"
    :selected="selected === chatGroup.id"
    @taphold="handleTapHold"
    @touchstart="handleTouchStart"
     @mouseenter="isHovered = true" 
    @mouseleave="isHovered = false"
  >
    <div class="item-media">
      <template v-if="isPersonal && counterpart">
        <img
          v-if="counterpart.avatar"
          class="tamtamBadge"
          :src="counterpart.avatar"
          width="40"
          style="height: 48px; width: 48px; border-radius: 25px"
        />
        <f7-badge
          v-else-if="counterpart.name"
          class="tamtamBadge"
          color="auto"
        >{{ $filtersGetInitial.getInitial(counterpart.name) }}</f7-badge>
      </template>
      <template v-else>
        <template v-if="chatGroup.avatar !== null">
          <img
            class="tamtamBadge"
            :src="chatGroup.avatar"
          />
          <f7-icon v-if="isGroupProtectedForUser" color="red" size="12" :style="{ position: 'absolute', bottom: '10%', left: '70%' }" f7="lock_fill"></f7-icon>
        </template>
        <f7-badge v-else class="tamtamBadge" color="auto">
          {{ $filtersGetInitial.getInitial(chatGroup.name) }}
          <f7-icon v-if="isGroupProtectedForUser" color="white" size="12" :style="{ position: 'absolute', bottom: '10%', left: '70%' }" f7="lock_fill"></f7-icon>
        </f7-badge>
      </template>
    </div>
    <div class="item-inner">
      <div class="item-title-row">
        <div class="item-title">{{ displayTitle }}</div>
        <div :class="'item-footer newMessageTime' + chatGroup.id">
          <span
            v-if="
              isActive &&
              activeMessageList &&
              activeMessageList.length > 0
            "
          >{{ $filtersToDate.msgDate(activeMessageList[0].sentAt, "time") }}</span>
          <span
            v-else-if="
              !isActive &&
              inactiveMessageList &&
              inactiveMessageList.length > 0
            "
          >{{ $filtersToDate.msgDate(inactiveMessageList[0].sentAt, "time") }}</span>
        </div>
      </div>
      <div class="item-subtitle">
        <div :class="'text-container isTypingFalse' + chatGroup.id">
          <span v-if="isActive && activeMessageList && activeMessageList.length > 0">
            <span v-if="isPersonal && activeMessageList[0].senderId === chatUser.userId">
              <f7-icon
                ios="f7:checkmark_alt"
                md="material:done"
                v-if="activeMessageList[0].status === 'sent'"
                color="gray"
                bg-color="white"
                style="border-radius: 50%; font-size: 120%; opacity: 1; background-color: var(--f7-message-sent-text-color);"
              ></f7-icon>
              <f7-icon
                ios="f7:checkmark_circle"
                md="material:done_all"
                v-if="activeMessageList[0].status === 'read'"
                style="border-radius: 50%; font-size: 120%; opacity: 1; background-color: var(--f7-message-sent-text-color);"
                color="auto"
              ></f7-icon>
            </span>
            <span v-if="!isPersonal && activeMessageList[0].senderId !== chatUser.userId"
            >{{ getSenderFirstName(activeMessageList[0].senderName) }}: </span>
            <span v-html="getMessageIcon(activeMessageList[0])"></span>
          </span>
          <span
            v-else-if="
              !isActive &&
              inactiveMessageList &&
              inactiveMessageList.length > 0
            "
          >
            <span v-if="isPersonal && inactiveMessageList[0].senderId === chatUser.userId">
              <f7-icon
                ios="f7:checkmark_alt"
                md="material:done"
                v-if="inactiveMessageList[0].status === 'sent'"
                color="gray"
                bg-color="white"
                style="border-radius: 50%; font-size: 120%; opacity: 1; background-color: var(--f7-message-sent-text-color);"
              ></f7-icon>
              <f7-icon
                ios="f7:checkmark_circle"
                md="material:done_all"
                v-if="inactiveMessageList[0].status === 'read'"
                style="border-radius: 50%; font-size: 120%; opacity: 1; background-color: var(--f7-message-sent-text-color);"
                color="auto"
              ></f7-icon>
            </span>
            <span v-if="!isPersonal && inactiveMessageList[0].senderId !== chatUser.userId"
            >{{ getSenderFirstName(inactiveMessageList[0].senderName) }}: </span>
            <span v-html="getMessageIcon(inactiveMessageList[0])"></span>
          </span>
        </div>
        <div
          :class="'text-container isTypingTrue' + chatGroup.id"
          style="display: none"
        ></div>
        <f7-badge
          v-if="unreadCount > 0"
          color="auto"
          :class="'unReadBadge unreadMessageBadge' + chatGroup.id"
        >{{ unreadCount }}</f7-badge>
        <f7-link id="chatMenuIncon-{{ chatGroup.id }}"
        v-if="!f7.support.touch || f7.device.desktop" 
          class="chat-menu-icon item-after"
          :class="{ 'display-none': !isHovered }"
          @click.stop="$emit('context-menu', chatGroup)"
          icon-ios="f7:chevron_down"
          icon-md="material:expand_more"
          style="right: 0px; position: absolute; top: 0px; color: gray;"
          ></f7-link>
        </div>
        <!-- v-->
      <div
        :class="'targetIcon' + chatGroup.id"
        style="right: 8px; position: absolute"
      ></div>
    </div>
  </a>
</template>
<style scoped>
/* .chatItem .chat-menu-icon {
  display: none;
}*/
.chat-menu-icon:hover {
  display: inline-block;
  position: absolute;
  right: 0px;
  color: gray;
} 
</style>

<script setup>
import { computed } from "vue";
import { f7 } from "framework7-vue";
import { useMessageStore } from "../../js/pinia-stores/message.js";
import { useAuthStore } from "../../js/pinia-stores/auth.js";
import { ref } from 'vue'
const props = defineProps({
  chatGroup: { type: Object, required: true },
  counterpart: { type: Object, default: null },
  isActive: { type: Boolean, default: false },
  isPersonal: { type: Boolean, default: false },
  activeMessageList: { type: Array, default: () => [] },
  isSubGroup: { type: Boolean, default: false },
  selected: { type: String, default: "" },
});

const emit = defineEmits(["navigate", "context-menu"]);
const isHovered = ref(false)
let isTapHold = false;
let clickTimeout = null;

const handleClick = () => {
  if (isTapHold) {
    return;
  }
  
  if (clickTimeout) {
    clearTimeout(clickTimeout);
  }
  
  clickTimeout = setTimeout(() => {
    if (!isTapHold) {
      emit('navigate', props.chatGroup);
    }
  }, 50);
};

const handleTapHold = () => {
  isTapHold = true;
  if (clickTimeout) {
    clearTimeout(clickTimeout);
    clickTimeout = null;
  }
  f7.taptic?.impact({ style: 'light' });
  emit('context-menu', props.chatGroup);
};

const handleTouchStart = () => {
  isTapHold = false;
  if (clickTimeout) {
    clearTimeout(clickTimeout);
    clickTimeout = null;
  }
};

const chatUser = computed(() => useMessageStore().chatUser);
const allGroupsUnReadMsg = computed(() => useMessageStore().allGroupsUnReadMsg);
const profile = computed(() => useAuthStore().profile);

const inactiveMessageList = computed(() => {
  if (props.isSubGroup) return props.chatGroup.subGroupMessageList || [];
  return props.chatGroup.groupMessageList || [];
});

const displayTitle = computed(() => {
  if (props.isPersonal && props.counterpart) {
    return props.counterpart.name
      || props.counterpart.username
      || props.counterpart.tag
      || "";
  }
  return props.chatGroup.name;
});

const unreadCount = computed(() => {
  const entry = allGroupsUnReadMsg.value?.find(
    (x) => x.id === props.chatGroup.id,
  );
  return entry?.count || 0;
});

const isGroupProtectedForUser = computed(() => {
  if (props.isPersonal) return false;
  if (!props.chatGroup.protectedBy || props.chatGroup.protectedBy.length === 0) {
    return false;
  }
  return props.chatGroup.protectedBy.some((x) => x.userId === profile.value.sub);
});

function getSenderFirstName(name) {
  return name.split(" ")[0];
}
f7.on(`chatItem${props.chatGroup.id}:hover`, () => {
f7.$(`chatItemIcon${props.chatGroup.id}`).show();
});
function getMessageIcon(message) {
  if (message.msgType === "video") {
    return `<span>  <i class="f7-icons if-not-md size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">videocam</i>  <i class="material-icons md-only size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">videocam</i>  <span>${
      message.fileName || "video"
    }</span></span>`;
  } else if (message.msgType === "audio") {
    return `<span>  <i class="f7-icons if-not-md size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">music_note_2</i>  <i class="material-icons md-only size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">audiotrack</i>  <span>${
      message.fileName || "audio"
    }</span></span>`;
  } else if (message.msgType === "image") {
    return `<span>  <i class="f7-icons if-not-md size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">photo</i>  <i class="material-icons md-only size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">image</i>  <span>${
      message.fileName || "photo"
    }</span></span>`;
  } else if (message.msgType === "file") {
    return `<span>  <i class="f7-icons if-not-md size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">doc_text</i>  <i class="material-icons md-only size-22" style="color:var(--f7-tabbar-link-inactive-color); font-size: 100%;">description</i>  <span>${
      message.fileName || "file"
    }</span></span>`;
  } else {
    return `<span>${message.text}</span>`;
  }
}
</script>
